import { useEffect, useRef, useState } from 'react';
import { Table, Spin } from 'antd';
import {} from '@ant-design/icons';
import { useEventEmitter } from '&/utils/customHooks/useEventEmitter';
import AdjunctUpload from '&/components/TemplateManagement/adjunctUpload';
import { addExamine } from '&/components/TemplateManagement/common';
import PreviewMedia from '&/components/TemplateManagement/previewMedia';
import './index.scss';

export default function Template(props) {
    const { type, templateData } = props;

    const adjunctUploadRef = useRef();

    const [loading, setLoading] = useState(false);

    useEffect(() => {}, []);

    const { emit } = useEventEmitter();

    /*const selectFile = () => {
        adjunctUploadRef.current.selectFile();
    };*/
    const editInspectionTemplate = async (data, editType) => {
        try {
            setLoading(true);
            const adjunct = templateData.children.map(item => {
                const { oriItem } = item;
                return {
                    url: oriItem.url,
                    size: oriItem.size,
                    fileType: oriItem.fileType,
                    name: oriItem.describe,
                    // isDelete: '',
                    adjunctId: oriItem.id,
                };
            });

            if (editType === 'add') {
                adjunct.push({
                    url: data.filePath,
                    size: data.fileSize,
                    fileType: data.fileType,
                    name: data.fileName,
                });
            } else if (editType === 'delete') {
                adjunct.forEach(item => {
                    if (item.adjunctId === data.id) {
                        item.isDelete = 1;
                    }
                });
            }
            const sendData = {
                templateId: templateData.id,
                constructionStage: templateData.constructionStage,
                acceptanceStandard: templateData.inspectionStandard,
                adjunct,
            };
            await addExamine(sendData);
            emit('query-template-list', { templateType: 'inspectionTemplate' });
            setLoading(false);
        } catch (e) {}
    };

    const acceptanceTemplateColumns = [
        {
            title: intl.get('base.serialNum'),
            dataIndex: 'index',
            align: 'center',
            width: '94px',
            render: (text, record, idx) => {
                return idx + 1;
            },
        },
        {
            title: intl.get('templateSettings.dominantItem'),
            dataIndex: 'dominantItem',
            ellipsis: true,
            width: '160px',
        },
        {
            title: intl.get('templateSettings.acceptanceStandard'),
            ellipsis: true,
            dataIndex: 'acceptanceStandard',
        },
    ];
    const acceptanceTemplateHeader = () => {
        return (
            <ul className="acceptance-template-header">
                <li>
                    <span className="header-item" style={{ width: '94px' }}>
                        {intl.get('templateSettings.testingTool')}
                    </span>
                    <p className="header-item">{templateData?.testingTool}</p>
                </li>
                <li>
                    <span className="header-item" style={{ width: '94px' }}>
                        {intl.get('templateSettings.constructionProcess')}
                    </span>
                    <p className="header-item">
                        {templateData?.constructionProcess}
                    </p>
                </li>
            </ul>
        );
    };
    const acceptanceTemplate = (
        <Table
            className="acceptance-template"
            bordered
            rowKey="id"
            title={acceptanceTemplateHeader}
            columns={acceptanceTemplateColumns}
            dataSource={templateData?.children}
            pagination={false}
        />
    );

    const getStepTemplate = (type, listKey) => {
        return (
            <div className="decorate-to-do-template">
                <ul className="decorating-to-do-list">
                    <li className="template-item">
                        <span className="item-label">
                            {intl.get('templateSettings.constructionStage')}：
                        </span>
                        <p className="item-value">
                            {templateData.constructionStage}
                        </p>
                    </li>
                    {type === 'decorateToDoTemplate' && (
                        <li className="template-item">
                            <span className="item-label">
                                {intl.get('templateSettings.deliveryTime')}：
                            </span>
                            <p className="item-value">
                                {intl.get('templateSettings.beforeStartTime', {
                                    day: templateData.beforeStartTime,
                                })}
                            </p>
                        </li>
                    )}
                    <li className="template-item">
                        <span className="item-label">
                            {intl.get('templateSettings.toDoList')}：
                        </span>
                        <ul className="item-list-box">
                            {templateData?.[listKey]?.map((item, index) => {
                                return (
                                    <li className="list-item" key={item.id}>
                                        <span className="list-item-index">
                                            {index + 1}、
                                        </span>
                                        <div className="list-item-content">
                                            <p className="list-item-text">
                                                {item.title}
                                            </p>
                                            {item.isAdjunct === '1' && (
                                                <p className="list-item-tip">
                                                    {intl.get(
                                                        'templateSettings.needUploadAttachment'
                                                    )}
                                                </p>
                                            )}
                                            <div className="img-list">
                                                {item.adjunct?.map(imgItem => (
                                                    <PreviewMedia
                                                        key={imgItem.id}
                                                        fileData={imgItem}
                                                        fileList={item.adjunct}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </li>
                </ul>
            </div>
        );
    };

    const templateMap = {
        acceptanceTemplate,
        decorateTemplate: getStepTemplate(
            'decorateToDoTemplate',
            'decoratingToDoList'
        ),
        inspectionTemplate: getStepTemplate(
            'inspectionTemplate',
            'inspectionList'
        ),
    };

    return (
        <div className="template-content">
            <Spin spinning={loading}>{templateMap[type]}</Spin>
            <AdjunctUpload
                ref={adjunctUploadRef}
                accept={[
                    'image/jpeg',
                    'image/png',
                    'application/pdf',
                    'image/bmp',
                ]}
                errMsg={intl.get('templateSettings.errAdjunctMsg')}
                change={fileResult => {
                    editInspectionTemplate(fileResult?.[0]?.data || {}, 'add');
                }}
            />
        </div>
    );
}
